import {
  deleteRequest,
  get,

  post,
  put,
} from "services/BaseClient/Client";
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";



export const getFavoriteListFilter = async (): Promise<DataResponse<any>> => {
  const url = `${endpoints.getFavoriteListFilter}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getPriceHistoryByAdvert = async (advertId:string): Promise<DataResponse<any>> => {
  const url = `${endpoints.getPriceHistoryByAdvert}/${advertId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};


export const addFavoriteList = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.addFavoriteListItem}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
};

export const updateFavoriteList = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.updateFavoriteListItem}`;
  const config = headers.content_type.application_json;
  return put<DataResponse<any>>(url, data,config);
};

export const deleteFavoriteList = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.deleteFavoriteListItem}/${data.id}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data,config);
};

export const getFavoriteAdvertList = async (listId:string): Promise<DataResponse<any>> => {

  const url = `${endpoints.getFavoriteAdvertList}/${listId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const addFavoriteAdvert = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.addFavoriteAdvert}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
};


export const deleteFavoriteAdvert = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.deleteFavoriteAdvert}/${data.id}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data,config);
};
export const resetAllItemsFavoriteList = async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.resetAllItemsOnFavoriteList}/${data.id}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data,config);
};
